// extracted by mini-css-extract-plugin
export default {"container":"Enheder_container__TkszM","opgangContainer":"Enheder_opgangContainer__CNhki","item":"Enheder_item__juOvU","enheder":"Enheder_enheder__SHRaX"};